import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px pb-3",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionYearlyPeriod.company_year_option, (year) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["menu-link px-3", 
          year == _ctx.optionYearlyPeriod.current_yearly_period ? 'active' : ''
        ]),
          onClick: ($event: any) => (_ctx.changeCurrentYearlyPeriod(year)),
          key: year
        }, _toDisplayString(year), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}